var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.QAsp),
      expression: "QAsp"
    }]
  }, [_c('div', {
    staticStyle: {
      "font-size": "20px",
      "float": "left",
      "margin": "-40px 0 0 40px",
      "font-weight": "600"
    }
  }, [_vm._v("OA审批")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "height": "750px",
      "background-color": "white",
      "margin": "75px 40px 0 40px"
    }
  }, [_c('div', {
    staticStyle: {
      "margin-left": "3%"
    }
  }, [_c('div', {
    staticStyle: {
      "height": "40px"
    }
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "inline-block",
      "margin-left": "20px"
    }
  }, [_c('span', [_vm._v("审批类型 ")]), _vm._v(" "), _c('el-select', {
    staticStyle: {
      "margin-left": "10px",
      "width": "180px"
    },
    attrs: {
      "placeholder": _vm.postPlaceholder,
      "clearable": ""
    },
    model: {
      value: (_vm.condition.examine_type),
      callback: function($$v) {
        _vm.$set(_vm.condition, "examine_type", $$v)
      },
      expression: "condition.examine_type"
    }
  }, _vm._l((_vm.typeList), function(item) {
    return _c('el-option', {
      key: item.value,
      attrs: {
        "label": item.label,
        "value": item.value
      }
    })
  }), 1)], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "inline-block",
      "margin-left": "20px"
    }
  }, [_c('span', [_vm._v("审批状态 ")]), _vm._v(" "), _c('el-select', {
    staticStyle: {
      "margin-left": "10px",
      "width": "180px"
    },
    attrs: {
      "placeholder": "请选择",
      "clearable": ""
    },
    model: {
      value: (_vm.condition.reviewer_state),
      callback: function($$v) {
        _vm.$set(_vm.condition, "reviewer_state", $$v)
      },
      expression: "condition.reviewer_state"
    }
  }, _vm._l((_vm.ztList), function(item) {
    return _c('el-option', {
      key: item.value,
      attrs: {
        "label": item.label,
        "value": item.value
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-input', {
    staticStyle: {
      "width": "180px",
      "margin-left": "10px"
    },
    attrs: {
      "placeholder": "请输入查询内容"
    },
    model: {
      value: (_vm.condition.staff_name),
      callback: function($$v) {
        _vm.$set(_vm.condition, "staff_name", $$v)
      },
      expression: "condition.staff_name"
    }
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "inline-block",
      "margin-left": "50px"
    }
  }, [_c('el-button', {
    attrs: {
      "type": "goon"
    },
    on: {
      "click": _vm.Find
    }
  }, [_vm._v("查询")])], 1)], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin": "2% 0 0 0"
    }
  }, [_c('el-table', {
    ref: "multipleTable",
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "header-cell-style": {
        background: '#F0F0F0',
        color: '#000000'
      },
      "row-class-name": _vm.tableRowClassName,
      "data": _vm.tableData,
      "tooltip-effect": "dark",
      "height": "520"
    },
    on: {
      "selection-change": _vm.handleSelectionChange
    }
  }, [_c('el-table-column', {
    attrs: {
      "type": "selection",
      "width": "55"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "align": "center",
      "label": "序号",
      "width": "50"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope_1) {
        return [_vm._v(_vm._s(scope_1.$index + 1))]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "examine_type_title",
      "align": "center",
      "label": "审批类型"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "examine_name",
      "label": "审批名称"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "create_time",
      "align": "center",
      "label": "提出时间"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "",
      "align": "center",
      "label": "状态",
      "width": "100"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('img', {
          directives: [{
            name: "show",
            rawName: "v-show",
            value: (scope.row.reviewer_state === '0'),
            expression: "scope.row.reviewer_state === '0'"
          }],
          attrs: {
            "src": require("../../../assets/待审批.png")
          }
        }), _vm._v(" "), _c('img', {
          directives: [{
            name: "show",
            rawName: "v-show",
            value: (scope.row.reviewer_state === '1'),
            expression: "scope.row.reviewer_state === '1'"
          }],
          attrs: {
            "src": require("../../../assets/已同意.png")
          }
        }), _vm._v(" "), _c('img', {
          directives: [{
            name: "show",
            rawName: "v-show",
            value: (scope.row.reviewer_state === '2'),
            expression: "scope.row.reviewer_state === '2'"
          }],
          attrs: {
            "src": require("../../../assets/stateImg/状态_已驳回.png")
          }
        })]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "create_time",
      "align": "center",
      "label": "通过时间"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "align": "center",
      "label": "操作",
      "width": "100"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('img', {
          attrs: {
            "src": require("../../../assets/岗位.png")
          },
          on: {
            "click": function($event) {
              return _vm.JieDian(scope.row.id)
            }
          }
        }), _vm._v(" "), _c('img', {
          attrs: {
            "src": require("../../../assets/详情.png")
          },
          on: {
            "click": function($event) {
              return _vm.xiangqing(scope.row)
            }
          }
        })]
      }
    }])
  })], 1), _vm._v(" "), _c('el-row', {
    staticStyle: {
      "margin-top": "10px",
      "text-align": "center"
    }
  }, [_c('el-pagination', {
    attrs: {
      "background": "",
      "page-size": _vm.page_size,
      "layout": " prev, pager, next, jumper",
      "total": _vm.total
    },
    on: {
      "current-change": _vm.handleCurrentChange
    }
  })], 1)], 1)])]), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "查看审批流程",
      "visible": _vm.jiedian,
      "width": "20%",
      "before-close": _vm.closeJiedian
    },
    on: {
      "update:visible": function($event) {
        _vm.jiedian = $event
      }
    }
  }, [_c('div', [_c('el-steps', {
    staticClass: "step",
    attrs: {
      "active": _vm.active,
      "finish-status": "success",
      "direction": "vertical"
    }
  }, _vm._l((_vm.jiedianList), function(item, index) {
    return _c('el-step', {
      key: index,
      attrs: {
        "title": item.name,
        "description": item.liyou
      }
    })
  }), 1)], 1)]), _vm._v(" "), _c('jbsq', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showjbsq),
      expression: "showjbsq"
    }],
    ref: "jbsqs",
    attrs: {
      "editData": _vm.editData,
      "id": _vm.id,
      "reviewer_state": _vm.reviewer_state
    }
  }), _vm._v(" "), _c('qjsq', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showqjsq),
      expression: "showqjsq"
    }],
    ref: "qjsqs",
    attrs: {
      "editData": _vm.editData,
      "id": _vm.id,
      "reviewer_state": _vm.reviewer_state
    }
  }), _vm._v(" "), _c('gwzysq', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showgwzysq),
      expression: "showgwzysq"
    }],
    ref: "gwzysqs",
    attrs: {
      "editData": _vm.editData,
      "id": _vm.id,
      "reviewer_state": _vm.reviewer_state
    }
  }), _vm._v(" "), _c('lzsq', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showlzsq),
      expression: "showlzsq"
    }],
    ref: "lzsqs",
    attrs: {
      "editData": _vm.editData,
      "id": _vm.id,
      "reviewer_state": _vm.reviewer_state
    }
  }), _vm._v(" "), _c('dgsq', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showdgsq),
      expression: "showdgsq"
    }],
    ref: "dgsqs",
    attrs: {
      "editData": _vm.editData,
      "id": _vm.id,
      "reviewer_state": _vm.reviewer_state
    }
  }), _vm._v(" "), _c('wcsq', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showwcsq),
      expression: "showwcsq"
    }],
    ref: "wcsqs",
    attrs: {
      "editData": _vm.editData,
      "id": _vm.id,
      "reviewer_state": _vm.reviewer_state
    }
  }), _vm._v(" "), _c('txsq', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showtxsq),
      expression: "showtxsq"
    }],
    ref: "txsqs",
    attrs: {
      "editData": _vm.editData,
      "id": _vm.id,
      "reviewer_state": _vm.reviewer_state,
      "is_reviewer_state": _vm.is_reviewer_state
    }
  }), _vm._v(" "), _c('bksq', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showbksq),
      expression: "showbksq"
    }],
    ref: "bksqs",
    attrs: {
      "editData": _vm.editData,
      "id": _vm.id,
      "reviewer_state": _vm.reviewer_state
    }
  }), _vm._v(" "), _c('ccsq', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showccsq),
      expression: "showccsq"
    }],
    ref: "ccsqs",
    attrs: {
      "editData": _vm.editData,
      "id": _vm.id,
      "reviewer_state": _vm.reviewer_state
    }
  }), _vm._v(" "), _c('cfsq', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showcfsq),
      expression: "showcfsq"
    }],
    ref: "cfsqs",
    attrs: {
      "editData": _vm.editData,
      "id": _vm.id,
      "reviewer_state": _vm.reviewer_state
    }
  }), _vm._v(" "), _c('rzsq', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showrzsq),
      expression: "showrzsq"
    }],
    ref: "rzsqs",
    attrs: {
      "editData": _vm.editData,
      "id": _vm.id,
      "reviewer_state": _vm.reviewer_state
    }
  }), _vm._v(" "), _c('tgsq', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showtgsq),
      expression: "showtgsq"
    }],
    ref: "tgsqs",
    attrs: {
      "editData": _vm.editData,
      "id": _vm.id,
      "reviewer_state": _vm.reviewer_state
    }
  }), _vm._v(" "), _c('zzsq', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showzzsq),
      expression: "showzzsq"
    }],
    ref: "zzsqs",
    attrs: {
      "editData": _vm.editData,
      "id": _vm.id,
      "reviewer_state": _vm.reviewer_state
    }
  }), _vm._v(" "), _c('gzmx', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showgzmx),
      expression: "showgzmx"
    }],
    ref: "gzmxs",
    attrs: {
      "editData": _vm.editData,
      "spare": _vm.spare,
      "id": _vm.id,
      "infor": _vm.infor,
      "examine_name": _vm.examine_name,
      "reviewer_state": _vm.reviewer_state,
      "is_reviewer_state": _vm.is_reviewer_state
    }
  }), _vm._v(" "), _c('gzzb', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showgzzb),
      expression: "showgzzb"
    }],
    ref: "gzzbs",
    attrs: {
      "editData": _vm.editData,
      "spare": _vm.spare,
      "id": _vm.id,
      "infor": _vm.infor,
      "examine_name": _vm.examine_name,
      "reviewer_state": _vm.reviewer_state,
      "is_reviewer_state": _vm.is_reviewer_state
    }
  }), _vm._v(" "), _c('gzhz', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showgzhz),
      expression: "showgzhz"
    }],
    ref: "gzhzs",
    attrs: {
      "editData": _vm.editData,
      "spare": _vm.spare,
      "id": _vm.id,
      "infor": _vm.infor,
      "examine_name": _vm.examine_name,
      "reviewer_state": _vm.reviewer_state,
      "is_reviewer_state": _vm.is_reviewer_state
    }
  })], 1)
}
var staticRenderFns = []
export default { render: render, staticRenderFns: staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-cb5b0aa8","transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/jcrsgl/QAsp/QAsp.vue
// module id = null
// module chunks = 